module.exports = __webpack_public_path__ + "static/img/20150629193341_FMTv2.a7faeac9.jpeg";